const ENVIRONMENT_ENUM = [
  'https://localhost',
  'https://dev-b2c.voegol.cloud',
  'https://hom-venda-b2c.voegol.com.br',
  'https://hom-tsts-venda-b2c.voegol.com.br',
  'https://hom-b2c.voegol.com.br',
  'https://hom-vcliente-b2c.voegol.com.br',
  'https://hom-minhasviagens-b2c.voegol.com.br',
  'https://sus-b2c.voegol.com.br',
  'https://hom-checkin-b2c.voegol.com.br',
  'https://hom-financeiro-b2c.voegol.com.br',
  'https://hom-posvenda-b2c.voegol.com.br',
  'https://hom-regressivo-b2c.voegol.com.br',
  'https://b2c.voegol.com.br',
];

export function redirectToGolDefault() {
  const origin = window.location.origin.toLocaleLowerCase();

  const isHmlEnv = origin.includes('hml') || origin.includes('uat');
  const isDevEnv = origin.includes('dev');
  const isLocalEnv = origin.includes('localhost');

  if (isHmlEnv || isDevEnv || isLocalEnv) {
    return 'https://hom-vcliente-b2c.voegol.com.br';
  }

  return 'https://www.voegol.com.br';
}
